import { FC } from "react";
import { Box, Tooltip } from "@mui/material";
import styled from "@mui/system/styled";

import { CsvError } from "components/CaseManagement/CsvErrors/CsvErrorFeedback";

export const CsvErrorCell: FC<CsvError> = error => {
  const hasErrors = !!error.errors?.length;

  return (
    <StyledTd>
      <Tooltip
        title={
          <Box sx={{ whiteSpace: "pre-wrap" }}>
            {hasErrors ? error.errors?.join("\n") : "Valid"}
          </Box>
        }
        placement="bottom-start"
        arrow
      >
        <Box
          component="span"
          sx={{ color: hasErrors ? "error.main" : "inherit" }}
        >
          {error.value || "<empty>"}
        </Box>
      </Tooltip>
    </StyledTd>
  );
};

const StyledTd = styled("td")`
  text-align: left;
  border: 1px solid #ccc;
  padding: ${props => props.theme.spacing(1)};
  white-space: nowrap;
`;
